import React from "react";

const FormWrapper = (props: any) => {
    return <div className="form-wrapper">{props.children}</div>;
}

export default FormWrapper;
